import { forwardRef, memo, useImperativeHandle } from 'react';
import { Flex } from '@chakra-ui/react';
import type { StepFormApi } from '@/hooks/useStepValidation';
import type { InterviewActivityStepProps } from '../AddInterviewActivity.interface';

export const InterviewActivityScorecard = memo(
  forwardRef<StepFormApi, InterviewActivityStepProps>(
    ({ payloadRef, prefillVersion: _prefillVersion }, ref) => {
      useImperativeHandle(
        ref,
        () => ({
          validate: async () => true,
          syncToPayload: () => {
            payloadRef.current.scorecard = {
              ...payloadRef.current.scorecard,
            };
          },
        }),
        [payloadRef]
      );

      return (
        <Flex
          justifyContent="center"
          w="100%"
          minH={0}
          flex="1"
          overflowY="auto"
        >
          Scorecard
        </Flex>
      );
    }
  )
);

InterviewActivityScorecard.displayName = 'InterviewActivityScorecard';
